
const popularCard = {
  title: '人気カード',
  links: [
    { label: '三井住友カード', href: '/mitsui' },
    { label: '大手ECモール系カード', href: '/rakuten' },
    { label: 'dカード GOLD U', href: '/dcard' },
    { label: 'デポジット型クレジットカード', href: '/nexus' },
  ],
};

export default popularCard;
